/**
 * Horizon's `<product-card>` binds a click handler to the whole card element, which navigates to
 * the product unless the click landed on a button, input, label or link. Empty space below the
 * card content therefore navigates too - and because a grid row stretches every card to the
 * tallest one, a short card has a lot of it.
 *
 * This listener runs on `document` in the capture phase, so it sees the click before the card's
 * own bubble-phase handler and stops it there. Only the gallery link and the product title link
 * (both real anchors) are left to navigate.
 */
const NAVIGATING_SELECTOR = 'a, button, input, label, select, textarea, summary';

document.addEventListener(
  'click',
  (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const card = target.closest('product-card');

    if (!card) return;

    // A click that landed on a real control or link is that element's to handle.
    if (target.closest(NAVIGATING_SELECTOR)) return;

    // Anything else inside the card is dead space as far as navigation goes.
    event.stopPropagation();
  },
  { capture: true }
);
